export default "__VITE_ASSET__C3YnKfaR__"